import React from 'react';

import { DesignTool } from '../../../../../../viewer/tools/design-tool';
import { SnappingDialogFrame } from '../../../../skyview-new/components/snapping-dialog/snapping-dialog';
import { SnappingOptions } from './sections/snapping-section';

/**
 * The snapping dialog of the design tool, while the option to show it is on, instead of the snap
 * sections of the menu. Closing it turns the option off, which shows those sections again.
 */
export const DesignSnappingDialog = (props: { tool: DesignTool; onClose: () => void }) => (
  // Wider than for the other tools, for the choices of the lines and offsets
  <SnappingDialogFrame
    refreshTooltip={() => props.tool.updateTooltip()}
    tool={props.tool}
    width={300}
    onClose={props.onClose}
  >
    <SnappingOptions tool={props.tool} />
  </SnappingDialogFrame>
);
